import { createTheme } from "@mantine/core";

export const theme = createTheme({
  primaryColor: "cyan",
  defaultRadius: "md",
  respectReducedMotion: true,
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  headings: {
    fontWeight: "600",
  },
});
